import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { FieldArray, Form, formValueSelector, reduxForm, } from 'redux-form';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { getRequestID } from 'components/shared/util/request';
import styles from './locations.module.scss';
import { Rules } from './locations/rules';
import { validate } from './locations/validation';
export const LOCATIONS_FIELD = 'rules';
const FORM_NAME = 'callFlowLocationsForm';
function LocationsImpl({ node, nodeLabel, rules, handleSubmit, replaceNode, triggerClose, dirty: isChanged, }) {
    const handleSaveClick = useCallback(({ rules }) => {
        var _a;
        const payload = {
            non_match_node_id: ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.non_match_node_id) || getRequestID(),
            rules: rules.map(({ name, match_node_id, matchings }) => ({
                name,
                match_node_id: match_node_id || getRequestID(),
                matchings: matchings.map((matching) => (Object.assign(Object.assign({}, matching), { rule: 'prefix', type: 'full-number' }))),
                rule_type: 'any',
            })),
        };
        const nodeOptions = Object.assign(Object.assign({}, node), { icon: 'i-th', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.LOCATIONS, overlay: [], payload, text: 'Locations' });
        replaceNode(nodeOptions);
        triggerClose();
    }, [node, replaceNode, triggerClose]);
    return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ className: styles.head, onClose: triggerClose, title: nodeLabel }, { children: _jsx("div", Object.assign({ className: styles.description }, { children: "Sort incoming calls based on country code. This is useful for general and specific locations (e.g. +44 for UK or +49035 for Dresden in Germany)." })) })), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleSaveClick) }, { children: [_jsx(ModalBody, Object.assign({ className: styles.body }, { children: _jsx(FieldArray, { name: LOCATIONS_FIELD, component: Rules, rules: rules }) })), _jsx(ModalFoot, { cancelOnClick: triggerClose, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, confirmOnClick: handleSubmit(handleSaveClick) })] }))] })));
}
const mapStateToProps = (state, ownProps) => {
    const DEFAULT_PAYLOAD = {
        rules: [
            {
                name: '',
                matchings: [
                    {
                        type: 'full-number',
                        rule: 'prefix',
                        match: '',
                    },
                ],
                rule_type: 'any',
            },
        ],
    };
    const payload = ownProps.node.payload || DEFAULT_PAYLOAD;
    const valueSelect = formValueSelector(FORM_NAME);
    return {
        initialValues: ownProps.node.payload || DEFAULT_PAYLOAD,
        payload,
        rules: valueSelect(state, 'rules') || payload.rules,
    };
};
export const Locations = connect(mapStateToProps)(reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    touchOnBlur: false,
    validate,
})(LocationsImpl));
